<template>
  <div style="overflow-x: scroll">
    <table class="table table-bordered">
      <thead>
        <tr>
          <th>Application ID</th>
          <th>Customer</th>
          <th>Vehicle ID</th>
          <th>Max Approval</th>
          <th>Sales Agent</th>
          <th>Status</th>
          <th>Application Status</th>
          <th>Last Modified</th>
          <th>Last Comment</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>88</td>
          <td>Thulani Felix Manyathi</td>
          <td>FRV0</td>
          <td>-</td>
          <td>Christopher Marshall</td>
          <td>Status</td>
          <td>Status</td>
          <td>Status</td>
          <td>Status</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "TableComp",
  props: {
    data: {
      type: Object,
      required: false,
    },
  },
};
</script>

<style scoped>
td,
th {
  white-space: nowrap;
  border: 2px solid white !important;
}
th {
  background-color: #e9e9e9 !important;
}
td {
  background-color: #f9f9f9 !important;
  text-align: start;
}
</style>
